import styles from './Mplace.module.css';

import React from 'react'
import { Col, Container, Row } from 'react-bootstrap';

import brands from '../../assets/imgs/brands.png';






export const Mplace = () => {
  return (
    <div>
        <Container fluid className={`bg-white h-100 ${styles.section}`}>
        <Container >
            <Row>
                <Col lg={6} sm={12} xs={12} md={6}>
                <h2 className={`${styles.title}`}>Marketplace and vendor offers</h2>
                <p className={`${styles.subtitle}`}>100’s of free tools and offers from our partners</p>
                <p className={`${styles.desc}`}>If you are a small business and need help getting online
                    at a budget, there are 100s of programmers here to help 
                    you build your first website, e-commerce store, or 
                    mobile app or web application and they work
                    according to your budget.</p>
                </Col>

                <Col lg={6} sm={12} xs={12} md={6}>

                {/* brands */}
                <div className={` ${styles.brand}`}>
                    <img src={brands} alt='brands' className={`ms-lg-auto img-fluid ${styles.brands}`} />  
                    </div>  

                </Col>
            </Row>
            </Container>
        </Container>
    </div>
  )
}
